<template>
    <v-dialog
        v-model="dialog"
        max-width="600px"
        persistent
        scrollable>

        <v-card>
            
           <v-toolbar dense :elevation="0">
                <v-toolbar-title class="grey--text text--darken-2">
                    Edit Deal
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
                <v-skeleton-loader
                    v-if="!deal"
                    class="pa-4"
                    type="table"
                    :loading="!schema"
                    :height="400"
                    :width="600"></v-skeleton-loader>
                <v-form v-else ref="form" v-model="valid" lazy-validation>
                        <!-- sections -->
                         <v-tabs grow v-model="tab" mandatory>
                            <v-tab v-for="type in schema.sections" :key="type">{{ type }}</v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="tab">

                            <!-- ====================== -->
                            <!-- Property Section Start -->
                            <!-- ====================== -->
                            <v-tab-item key="property">
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <entity-autocomplete
                                                v-if="schema.fields.includes('property_id')"
                                                v-model="deal.property_id"
                                                label="Property"
                                                endpoint="/properties"
                                                :params="{ include: 'scheme, address, scheme.address' }"
                                                outlined
                                                dense
                                                item-text="address.data.full_address"
                                                item-value="id"
                                                clearable
                                            ></entity-autocomplete>
                                        </v-col>
                                        <v-col cols="12" id="address" v-if="schema.fields.includes('address')">
                                            <!-- street , street 2 -->
                                            <v-row>
                                                <v-col cols="6">
                                                    <v-text-field
                                                        v-model="deal.property.address.street"
                                                        label="Street"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        :rules="[rules.required]"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field
                                                        v-model="deal.property.address.street2"
                                                        label="Street 2"
                                                        outlined
                                                        dense
                                                        hide-details
                                                    ></v-text-field>
                                                </v-col>
                                                <!-- city, region, postcode -->
                                                <v-col cols="4">
                                                    <v-text-field
                                                        v-model="deal.property.address.city"
                                                        label="City"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        :rules="[rules.required]"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field
                                                        v-model="deal.property.address.region"
                                                        label="Region"
                                                        outlined
                                                        dense
                                                        hide-details
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field
                                                        v-model="deal.property.address.post_code"
                                                        label="Postcode"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        :rules="[rules.required]"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-tab-item>
                            <!-- ===================== -->
                            <!-- Property Section End -->
                            <!-- ===================== -->

                            <!-- ====================== -->
                            <!-- Contact Section Start -->
                            <!-- ====================== -->
                            <v-tab-item key="contacts">
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <entity-autocomplete
                                                v-if="schema.fields.includes('client_id')"
                                                v-model="deal.client_id"
                                                label="Client"
                                                endpoint="/clients"
                                                :params="{ include: 'scheme, address, scheme.address' }"
                                                outlined
                                                dense
                                                item-text="name"
                                                item-value="id"
                                                clearable
                                            ></entity-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <entity-autocomplete
                                                v-if="schema.fields.includes('tenant_id')"
                                                v-model="deal.tenant_id"
                                                label="Tenant"
                                                endpoint="/tenants"
                                                :params="{ include: 'scheme, address, scheme.address' }"
                                                outlined
                                                dense
                                                item-text="name"
                                                item-value="id"
                                                clearable
                                            ></entity-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-tab-item>
                            <!-- ===================== -->
                            <!-- Contact Section End -->
                            <!-- ===================== -->
                        </v-tabs-items>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed outlined text @click="dialog = false">Cancel</v-btn>
                <v-btn depressed color="primary" >Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import dealSchema from '@/schemas/dealSchema.js';
import entityAutocomplete from '@/components/common/entityAutocomplete.vue';
export default {
    name: 'EditDealDialog',
    components: {
        entityAutocomplete
    },
    data() {
        return {
            valid: false,
            dialog: false,
            tab: null,

            deal:{},
            schema: {},
            
            rules: {
                required: value => !!value || 'Required.'
            },
            statuses: ['Open', 'In Progress', 'Closed']
        };
    },
    watch: {
        dialog(val) {
            if (val) {
                this.resetForm();
            }
        }
    },
    methods: {
        closeDialog() {
            this.dialog = false;
        },
        showDialog(deal) {
            this.dialog = true;
            
            this.getDeal(deal);

            // get schema for the deal type
            
            
        },

        async getDeal(id){
            await this.$http.get(`/deals/${id}`, {
                    params: {
                        include: 'scheme, property, property.address, property.scheme, client, tenant, prev_tenant, tenant_legal, prev_tenant_legal, landlords, landlord_contacts, landlord_agents, landlord_agent_contacts, prev_landlords, prev_landlord_contacts, prev_landlord_agents, prev_landlord_agent_contacts, tenant_contacts, tenant_agents, tenant_agent_contacts, prev_tenant_contacts, prev_tenant_agents, prev_tenant_agent_contacts, creator, links',
                    }
                }).then(response => {
                    this.schema = dealSchema[response.data.deal_type];
                    this.deal = response.data;
                }).catch(error => {
                    console.error('Error fetching deal:', error);
                });
        },

        resetForm() {
        },
    },
};

</script>